export const founders = [
  {
    name: "Arq. Santiago Caballero Cabrera",
    position: "Director / Fundador",
    img_src: "SantiagoCaballeroCabrera",
  },
  {
    name: "Arq. Martin Bonilla Bernadet",
    position: "Director / Fundador",
    img_src: "MartinBonillaBernadet",
  },
];

export const people = [
  {
    name: "Arq. Loanna Perera Oliver",
    position: "Líder de Obras",
    img_src: "LoannaPereiraOliver",
  },
  {
    name: "Jorge Valdivia Perdomo",
    position: "Líder de Visualización",
    img_src: "JorgeValdiviaPerdomo",
  },
  {
    name: "Arq. Victoria Cirillo Chiarle",
    position: "Líder de Proyectos",
    img_src: "VictoriaCirilloChiarle",
  },
];
